import React from 'react';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { usePredictedCloseVolumeCapsuleData } from './predictedVolumeCapsuleData';
import {
    usePortfolioSelectedSymbolQuantity,
    usePortfolioStreamedOrSelectedPositionFromOrders,
} from 'portfolio/store/hooks';

import './PredictedVolumeCapsule.scss';
import { usePredictedVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/predictedVolumeCapsule/state/config/configslice';
import PredictedVolumeCapsuleHelp from 'widgets/liquiditySummary/predictedVolumeCapsule/components/PredictedVolumeCapsuleHelp';
import { PredictedVolumeCapsuleContent } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/PredictedVolumeCapsuleContent';
import { useWarningForOrderDependentCapsulesSupportingSymbolQuantity } from 'widgets/tiles/components/tile/hooks';
import InfoBox from 'utils/components/InfoBox/InfoBox';

/*
 * Note that this is both the Predicted Volume Capsule and the Predicted Close Capsule
 * The only difference between the two is via config (which is hidden from the user)
 */
export function PredictedVolumeCapsule() {
    useWidgetStream();

    const {
        config: { includePredContinuousTrading },
    } = usePredictedVolumeCapsuleConfigSlice();

    const isPredRemainingCaspule = includePredContinuousTrading;

    const title = isPredRemainingCaspule
        ? 'Predicted Remaining Volume'
        : 'Predicted Close Volume';

    const position = usePortfolioStreamedOrSelectedPositionFromOrders();
    const symbolQuantity = usePortfolioSelectedSymbolQuantity();

    const side = position
        ? position.side
        : (symbolQuantity?.qty ?? 0) > 0
        ? 'B'
        : 'S';

    const { useWidgetMessages } = liquidityStreamedDataSelectors;
    const messages = useWidgetMessages();

    const chartData = usePredictedCloseVolumeCapsuleData();

    const warning =
        useWarningForOrderDependentCapsulesSupportingSymbolQuantity();

    return (
        <WidgetTile className="PredictedVolumeCapsule">
            <TileToolbar
                title={title}
                preceedingItems={<PredictedVolumeCapsuleHelp />}
                messages={messages}
                wideTitle={true}
            />

            <div className="capsule-body">
                {warning && <InfoBox info={warning} />}
                {!warning && !chartData && <>No data</>}
                {!warning && chartData && (
                    <PredictedVolumeCapsuleContent
                        chartData={chartData}
                        cssClasses={'side-' + side}
                    />
                )}
            </div>
        </WidgetTile>
    );
}
